<div class="loading-overlay" *ngIf="loading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="min-h-screen bg-white">
  <div class="max-w-full mx-auto py-6">
        <div class="strategies-table-container">
        <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4 relative">
          <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
            <div class="relative w-full max-w-xs">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
              <input
                type="text"
                class="search-input-strategies w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
                [(ngModel)]="searchTerm"
                (input)="applyFilter()"
                placeholder="Rechercher par opérateur, type..."
              />
            </div>
            <select 
              class="strategies-filter-select px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none bg-white cursor-pointer"
              [(ngModel)]="typeStrategieFilter"
              (change)="onTypeStrategieFilterChange()">
              <option value="all">Tous les types</option>
              <option value="court terme">Court terme</option>
              <option value="long terme">Long terme</option>
            </select>
            <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
              {{ getFilteredStrategiesCount() }} stratégie{{ getFilteredStrategiesCount() > 1 ? 's' : '' }}
            </span>
          </div>
          
          <button 
            *ngIf="archiveFilter !== 'archived'"
            class="add-strategy-button bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden"
            (click)="openAddModal()"
            title="Ajouter une stratégie">
            <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">add</span>
            <span class="add-strategy-button-text text-sm font-medium whitespace-nowrap">Ajouter une stratégie</span>
          </button>
        </div>

        <div class="archive-toggle-bar mb-3">
          <button
            type="button"
            class="archive-toggle-card"
            [ngClass]="{ 'active': archiveFilter === 'active' }"
            (click)="setArchiveFilter('active')">
            <span class="material-symbols-outlined">memory</span>
            <div class="archive-toggle-content">
              <div class="archive-toggle-title">Stratégies actives</div>
              <div class="archive-toggle-count">{{ getArchiveCount('active') }}</div>
            </div>
          </button>

          <button
            type="button"
            class="archive-toggle-card"
            [ngClass]="{ 'active': archiveFilter === 'archived' }"
            (click)="setArchiveFilter('archived')">
            <span class="material-symbols-outlined">archive</span>
            <div class="archive-toggle-content">
              <div class="archive-toggle-title">Archives</div>
              <div class="archive-toggle-count">{{ getArchiveCount('archived') }}</div>
            </div>
          </button>

          <button
            type="button"
            class="archive-toggle-card"
            [ngClass]="{ 'active': archiveFilter === 'all' }"
            (click)="setArchiveFilter('all')">
            <span class="material-symbols-outlined">all_inclusive</span>
            <div class="archive-toggle-content">
              <div class="archive-toggle-title">Tout afficher</div>
              <div class="archive-toggle-count">{{ getFilteredAllCount() }}</div>
            </div>
          </button>
        </div>

        <div class="strategies-list-container p-6">
          <div class="space-y-4" *ngIf="filteredStrategies.length > 0; else noStrategies">
            <div class="strategy-card-modern" *ngFor="let s of filteredStrategies">
              <div class="strategy-card-header">
                <div class="strategy-card-info">
                  <h3 class="strategy-name-modern">{{ s.operateur }}</h3>
                  <span class="strategy-type-badge" 
                        [ngClass]="s.typeStrategie === 'court terme' ? 'strategy-type-short' : 'strategy-type-long'">
                    {{ s.typeStrategie | uppercase }}
                  </span>
                </div>
                <div class="strategy-card-actions">
                  <button 
                    class="btn-action-strategy btn-archive-strategy" 
                    (click)="toggleArchiveStrategy(s)" 
                    [title]="s.isArchive ? 'Désarchiver' : (hasActiveMachines(s._id) ? 'Impossible d\'archiver : utilisée par des machines actives' : 'Archiver')"
                    [disabled]="loading || (!s.isArchive && hasActiveMachines(s._id))">
                    <span class="material-symbols-outlined">
                      {{ s.isArchive ? 'unarchive' : 'archive' }}
                    </span>
                  </button>
                  <button 
                    class="btn-action-strategy btn-edit-strategy" 
                    (click)="openEditModal(s)" 
                    title="Modifier">
                    <span class="material-symbols-outlined">edit</span>
                  </button>
                  <button 
                    class="btn-action-strategy btn-delete-strategy" 
                    (click)="delete(s._id)" 
                    title="Supprimer" 
                    [disabled]="loading">
                    <span class="material-symbols-outlined">delete</span>
                  </button>
                </div>
              </div>

              <div class="strategy-card-content">
                <div class="strategy-details-grid">
                  <div class="strategy-detail-item">
                    <span class="strategy-detail-label">Type d'envoi</span>
                    <span class="strategy-detail-value">{{ s.typeEnvoi }}</span>
                  </div>
                  
                  <div class="strategy-detail-item" *ngIf="s.prixCarte">
                    <span class="strategy-detail-label">Prix carte</span>
                    <span class="strategy-detail-value">{{ s.prixCarte }}$</span>
                  </div>
                  
                  <div class="strategy-detail-item">
                    <span class="strategy-detail-label">Puces simultanées</span>
                    <span class="strategy-detail-value">{{ s.nbMaxPuceSimultanee }}</span>
                  </div>
                  
                  <div class="strategy-detail-item" *ngIf="(s.typeEnvoi === 'SMS' || s.typeEnvoi === 'SMS & MMS') && s.typeStrategie === 'court terme' && s.minuteDebutSMS && s.minuteFinSMS">
                    <span class="strategy-detail-label">SMS - Minutes</span>
                    <span class="strategy-detail-value">
                      Début: {{ s.minuteDebutSMS?.join(',') }} | Fin: {{ s.minuteFinSMS?.join(',') }}
                    </span>
                  </div>
                  
                  <div class="strategy-detail-item" *ngIf="(s.typeEnvoi === 'MMS' || s.typeEnvoi === 'SMS & MMS') && s.typeStrategie === 'court terme' && s.minuteDebutMMS && s.minuteFinMMS">
                    <span class="strategy-detail-label">MMS - Minutes</span>
                    <span class="strategy-detail-value">
                      Début: {{ s.minuteDebutMMS?.join(',') }} | Fin: {{ s.minuteFinMMS?.join(',') }}
                    </span>
                  </div>
                  
                  <ng-container *ngIf="s.typeEnvoi === 'SMS' || s.typeEnvoi === 'SMS & MMS'">
                    <div class="strategy-detail-item" *ngIf="s.quotaMinSMS > 0">
                      <span class="strategy-detail-label">Quota SMS/min</span>
                      <span class="strategy-detail-value">{{ s.quotaMinSMS }}/min</span>
                    </div>
                    <div class="strategy-detail-item" *ngIf="s.quotaHSMS > 0">
                      <span class="strategy-detail-label">Quota SMS/heure</span>
                      <span class="strategy-detail-value">{{ s.quotaHSMS }}/h</span>
                    </div>
                    <div class="strategy-detail-item" *ngIf="s.typeStrategie === 'court terme' && s.quotaFixeSMS > 0">
                      <span class="strategy-detail-label">Quota fixe SMS</span>
                      <span class="strategy-detail-value">{{ s.quotaFixeSMS }}</span>
                    </div>
                    <div class="strategy-detail-item" *ngIf="s.typeStrategie === 'long terme' && s.quotaJourSMS > 0">
                      <span class="strategy-detail-label">Quota SMS/jour</span>
                      <span class="strategy-detail-value">{{ s.quotaJourSMS }}/jour</span>
                    </div>
                  </ng-container>
                  
                  <ng-container *ngIf="s.typeEnvoi === 'MMS' || s.typeEnvoi === 'SMS & MMS'">
                    <div class="strategy-detail-item" *ngIf="s.quotaMinMMS > 0">
                      <span class="strategy-detail-label">Quota MMS/min</span>
                      <span class="strategy-detail-value">{{ s.quotaMinMMS }}/min</span>
                    </div>
                    <div class="strategy-detail-item" *ngIf="s.quotaHMMS > 0">
                      <span class="strategy-detail-label">Quota MMS/heure</span>
                      <span class="strategy-detail-value">{{ s.quotaHMMS }}/h</span>
                    </div>
                    <div class="strategy-detail-item" *ngIf="s.typeStrategie === 'court terme' && s.quotaFixeMMS > 0">
                      <span class="strategy-detail-label">Quota fixe MMS</span>
                      <span class="strategy-detail-value">{{ s.quotaFixeMMS }}</span>
                    </div>
                    <div class="strategy-detail-item" *ngIf="s.typeStrategie === 'long terme' && s.quotaJourMMS > 0">
                      <span class="strategy-detail-label">Quota MMS/jour</span>
                      <span class="strategy-detail-value">{{ s.quotaJourMMS }}/jour</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <ng-template #noStrategies>
            <div class="text-center py-12">
              <span class="material-symbols-outlined text-6xl text-gray-300 mb-4">settings</span>
              <p class="text-gray-500 text-lg">Aucune stratégie configurée</p>
              <button 
                *ngIf="archiveFilter !== 'archived'"
                class="add-strategy-button bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm mx-auto overflow-hidden"
                (click)="openAddModal()">
                <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">add</span>
                <span class="add-strategy-button-text text-sm font-medium whitespace-nowrap">Ajouter une stratégie</span>
              </button>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
</div>

<div class="strategies-modal-overlay" *ngIf="showEditModal">
  <div class="strategies-modal-content" #editModalContent>
    <div class="strategies-modal-header">
      <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-sm">
          <span class="material-symbols-outlined text-white text-lg">edit</span>
        </div>
        <h2 class="text-base font-semibold text-gray-900 tracking-tight">Modifier la stratégie</h2>
      </div>
      <button 
        class="modal-close-btn w-9 h-9 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-50 active:bg-gray-100 transition-all duration-200"
        (click)="closeEditModal()" 
        type="button"
        [disabled]="isUpdating"
        title="Fermer">
        <span class="material-symbols-outlined text-xl">close</span>
      </button>
    </div>
    
    <div class="strategies-modal-body" *ngIf="editingStrategy">
      <form (ngSubmit)="saveEdit(); $event.preventDefault()" id="editForm">
        <div class="mb-6">
          <div class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Opérateur
                </label>
                <input 
                  type="text" 
                  class="strategies-form-input" 
                  [(ngModel)]="editingStrategy.operateur" 
                  name="editOperateur" 
                  placeholder="Ex: Orange, SFR, Free..." />
              </div>
              
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Prix carte
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="strategies-form-input" 
                  [(ngModel)]="editingStrategy.prixCarte" 
                  name="editPrixCarte" 
                  placeholder="Ex: 10.50" 
                  step="0.01" 
                  min="0.01" 
                  required />
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Type de stratégie
                </label>
                <select 
                  class="strategies-form-select" 
                  [(ngModel)]="editingStrategy.typeStrategie" 
                  name="editTypeStrategie" 
                  (change)="onTypeStrategieChange(editingStrategy)">
                  <option value="court terme">Court terme (One shot)</option>
                  <option value="long terme">Long terme</option>
                </select>
              </div>
              
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Type d'envoi
                  <span class="text-red-500">*</span>
                </label>
                <select 
                  class="strategies-form-select" 
                  [(ngModel)]="editingStrategy.typeEnvoi" 
                  name="editTypeEnvoi" 
                  (change)="onTypeEnvoiChange(editingStrategy)">
                  <option value="SMS">SMS uniquement</option>
                  <option value="MMS">MMS uniquement</option>
                  <option value="SMS & MMS">SMS + MMS</option>
                </select>
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Nombre de puces simultanées
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="strategies-form-input" 
                  [(ngModel)]="editingStrategy.nbMaxPuceSimultanee" 
                  name="editNbMaxPuceSimultanee" 
                  placeholder="Ex: 3"
                  min="1" />
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="editingStrategy.typeEnvoi === 'SMS' || editingStrategy.typeEnvoi === 'SMS & MMS'">
          <div class="border-t border-gray-100 pt-4 mb-4">
            <h6 class="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-blue-600">message</span>
              Paramètres SMS
            </h6>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="editingStrategy.typeStrategie === 'court terme'">
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de début SMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.minuteDebutSMS" 
                    name="editMinuteDebutSMS" 
                    placeholder="Ex: 0,15,30" />
                </div>
                
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de fin SMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.minuteFinSMS" 
                    name="editMinuteFinSMS" 
                    placeholder="Ex: 10,25,40" />
                </div>
              </div>

              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par minute
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaMinSMS" 
                    name="editQuotaMinSMS" 
                    placeholder="Ex: 5"
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par heure
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaHSMS" 
                    name="editQuotaHSMS" 
                    placeholder="Ex: 100"
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    <span *ngIf="editingStrategy.typeStrategie === 'court terme'">Quota fixe SMS</span>
                    <span *ngIf="editingStrategy.typeStrategie !== 'court terme'">Quota par jour</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    *ngIf="editingStrategy.typeStrategie === 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaFixeSMS" 
                    name="editQuotaFixeSMS" 
                    placeholder="Ex: 1000" 
                    min="1" />
                  <input 
                    *ngIf="editingStrategy.typeStrategie !== 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaJourSMS" 
                    name="editQuotaJourSMS" 
                    placeholder="Ex: 500"
                    min="1" />
                </div>
              </div>
              
              <div *ngIf="editingStrategy.typeStrategie === 'court terme'">
                <small class="text-xs text-gray-500">Nombre total de SMS à envoyer pour cette stratégie</small>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="editingStrategy.typeEnvoi === 'MMS' || editingStrategy.typeEnvoi === 'SMS & MMS'">
          <div class="border-t border-gray-100 pt-4">
            <h6 class="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-purple-600">image</span>
              Paramètres MMS
            </h6>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="editingStrategy.typeStrategie === 'court terme'">
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de début MMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.minuteDebutMMS" 
                    name="editMinuteDebutMMS" 
                    placeholder="Ex: 5,20" />
                </div>
                
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de fin MMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.minuteFinMMS" 
                    name="editMinuteFinMMS" 
                    placeholder="Ex: 15,35" />
                </div>
              </div>

              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par minute
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaMinMMS" 
                    name="editQuotaMinMMS" 
                    placeholder="Ex: 2"
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par heure
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaHMMS" 
                    name="editQuotaHMMS" 
                    placeholder="Ex: 50"
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    <span *ngIf="editingStrategy.typeStrategie === 'court terme'">Quota fixe MMS</span>
                    <span *ngIf="editingStrategy.typeStrategie !== 'court terme'">Quota par jour</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    *ngIf="editingStrategy.typeStrategie === 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaFixeMMS" 
                    name="editQuotaFixeMMS" 
                    placeholder="Ex: 100" 
                    min="1" />
                  <input 
                    *ngIf="editingStrategy.typeStrategie !== 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="editingStrategy.quotaJourMMS" 
                    name="editQuotaJourMMS" 
                    placeholder="Ex: 200"
                    min="1" />
                </div>
              </div>
              
              <div *ngIf="editingStrategy.typeStrategie === 'court terme'">
                <small class="text-xs text-gray-500">Nombre total de MMS à envoyer pour cette stratégie</small>
              </div>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
    
    <div class="strategies-modal-footer">
      <button 
        type="button" 
        class="strategies-btn-secondary"
        (click)="closeEditModal()"
        [disabled]="isUpdating">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="strategies-btn-primary"
        form="editForm"
        [disabled]="isUpdating">
        <span *ngIf="!isUpdating" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">save</span>
          <span>Enregistrer</span>
        </span>
        <span *ngIf="isUpdating" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Enregistrement...</span>
        </span>
      </button>
    </div>
  </div>
</div>

<div class="strategies-modal-overlay" *ngIf="showAddModal">
  <div class="strategies-modal-content" #addModalContent>
    <div class="strategies-modal-header">
      <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-sm">
          <span class="material-symbols-outlined text-white text-lg">add</span>
        </div>
        <h2 class="text-base font-semibold text-gray-900 tracking-tight">Ajouter une nouvelle stratégie</h2>
      </div>
      <button 
        class="modal-close-btn w-9 h-9 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-50 active:bg-gray-100 transition-all duration-200"
        (click)="closeAddModal()" 
        type="button"
        [disabled]="isAdding"
        title="Fermer">
        <span class="material-symbols-outlined text-xl">close</span>
      </button>
    </div>
    
    <div class="strategies-modal-body">
      <form (ngSubmit)="addStrategy(); $event.preventDefault()" id="addForm">
        <div class="mb-4">
          <div class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Opérateur
                </label>
                <input 
                  type="text" 
                  class="strategies-form-input" 
                  [(ngModel)]="newStrategy.operateur" 
                  name="newOperateur" 
                  placeholder="Ex: Orange, SFR, Free..." />
              </div>
              
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Prix carte
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="strategies-form-input" 
                  [(ngModel)]="newStrategy.prixCarte" 
                  name="newPrixCarte" 
                  placeholder="Ex: 10.50" 
                  step="0.01" 
                  min="0.01" 
                  required />
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Type de stratégie
                </label>
                <select 
                  class="strategies-form-select" 
                  [(ngModel)]="newStrategy.typeStrategie" 
                  name="newTypeStrategie" 
                  (change)="onTypeStrategieChange(newStrategy)">
                  <option value="">Sélectionner...</option>
                  <option value="court terme">Court terme (One shot)</option>
                  <option value="long terme">Long terme</option>
                </select>
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Type d'envoi
                  <span class="text-red-500">*</span>
                </label>
                <select 
                  class="strategies-form-select" 
                  [(ngModel)]="newStrategy.typeEnvoi" 
                  name="newTypeEnvoi" 
                  (change)="onTypeEnvoiChange(newStrategy)">
                  <option value="">Sélectionner...</option>
                  <option value="SMS">SMS uniquement</option>
                  <option value="MMS">MMS uniquement</option>
                  <option value="SMS & MMS">SMS + MMS</option>
                </select>
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Nombre de puces simultanées
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="strategies-form-input" 
                  [(ngModel)]="newStrategy.nbMaxPuceSimultanee" 
                  name="newNbMaxPuceSimultanee" 
                  placeholder="Ex: 3" 
                  min="1" />
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="newStrategy.typeEnvoi === 'SMS' || newStrategy.typeEnvoi === 'SMS & MMS'">
          <div class="border-t border-gray-100 pt-4 mb-4">
            <h6 class="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-blue-600">message</span>
              Paramètres SMS
            </h6>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="newStrategy.typeStrategie === 'court terme'">
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de début SMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.minuteDebutSMS" 
                    name="newMinuteDebutSMS" 
                    placeholder="Ex: 0,15,30" />
                </div>
                
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de fin SMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.minuteFinSMS" 
                    name="newMinuteFinSMS" 
                    placeholder="Ex: 10,25,40" />
                </div>
              </div>

              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par minute
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaMinSMS" 
                    name="newQuotaMinSMS" 
                    placeholder="Ex: 5" 
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par heure
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaHSMS" 
                    name="newQuotaHSMS" 
                    placeholder="Ex: 100" 
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    <span *ngIf="newStrategy.typeStrategie === 'court terme'">Quota fixe SMS</span>
                    <span *ngIf="newStrategy.typeStrategie !== 'court terme'">Quota par jour</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    *ngIf="newStrategy.typeStrategie === 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaFixeSMS" 
                    name="newQuotaFixeSMS" 
                    placeholder="Ex: 1000" 
                    min="1" />
                  <input 
                    *ngIf="newStrategy.typeStrategie !== 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaJourSMS" 
                    name="newQuotaJourSMS" 
                    placeholder="Ex: 500" 
                    min="1" />
                </div>
              </div>
              
              <div *ngIf="newStrategy.typeStrategie === 'court terme'">
                <small class="text-xs text-gray-500">Nombre total de SMS à envoyer pour cette stratégie</small>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="newStrategy.typeEnvoi === 'MMS' || newStrategy.typeEnvoi === 'SMS & MMS'">
          <div class="border-t border-gray-100 pt-4">
            <h6 class="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-purple-600">image</span>
              Paramètres MMS
            </h6>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="newStrategy.typeStrategie === 'court terme'">
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de début MMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.minuteDebutMMS" 
                    name="newMinuteDebutMMS" 
                    placeholder="Ex: 5,20" />
                </div>
                
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de fin MMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.minuteFinMMS" 
                    name="newMinuteFinMMS" 
                    placeholder="Ex: 15,35" />
                </div>
              </div>

              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par minute
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaMinMMS" 
                    name="newQuotaMinMMS" 
                    placeholder="Ex: 2" 
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par heure
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaHMMS" 
                    name="newQuotaHMMS" 
                    placeholder="Ex: 50" 
                    min="1" />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    <span *ngIf="newStrategy.typeStrategie === 'court terme'">Quota fixe MMS</span>
                    <span *ngIf="newStrategy.typeStrategie !== 'court terme'">Quota par jour</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    *ngIf="newStrategy.typeStrategie === 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaFixeMMS" 
                    name="newQuotaFixeMMS" 
                    placeholder="Ex: 100" 
                    min="1" />
                  <input 
                    *ngIf="newStrategy.typeStrategie !== 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [(ngModel)]="newStrategy.quotaJourMMS" 
                    name="newQuotaJourMMS" 
                    placeholder="Ex: 200" 
                    min="1" />
                </div>
              </div>
              
              <div *ngIf="newStrategy.typeStrategie === 'court terme'">
                <small class="text-xs text-gray-500">Nombre total de MMS à envoyer pour cette stratégie</small>
              </div>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
    
    <div class="strategies-modal-footer">
      <button 
        type="button" 
        class="strategies-btn-secondary"
        (click)="closeAddModal()"
        [disabled]="isAdding">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="strategies-btn-primary"
        form="addForm"
        [disabled]="isAdding">
        <span *ngIf="!isAdding" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">add</span>
          <span>Ajouter</span>
        </span>
        <span *ngIf="isAdding" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Ajout...</span>
        </span>
      </button>
    </div>
  </div>
</div>

<app-confirmation-modal
  [isVisible]="showModal"
  [config]="modalConfig"
  (confirm)="onModalConfirm()"
  (cancel)="onModalClose()"
  (close)="onModalClose()">
</app-confirmation-modal>
